import "react-toastify/dist/ReactToastify.css";
import icons from "../../lib/icons";
import { Outlet, useNavigate } from "react-router-dom";
import TabSwitcher from "../../shared/TabSwitcher";
import NumericFormat from "react-number-format";
import { useContext } from "react";
import { WithdrawContext } from "../../context/WithdrawContext";

function WithdrawalsLayout() {
  const { balance, transferType, setTransferType, isPending } =
    useContext(WithdrawContext);
  const navigate = useNavigate();
 
  
  const tabOptions = [
    {
      title: "انتقال وجه داخلی",
      value: "internal",
      path: "/withdrawals/transfer",
      active: process.env.REACT_APP_INTERNAL_WITHDRAW_ACTIVE_MODE === "ACTIVE",
    },
    {
      title: "انتقال وجه ",
      value: "external",
      path: "/withdrawals/transfer",
      active: true,
    },
  ];

 

  const handleSwitch = (value) => {
    const selectedTab = tabOptions.find((tab) => tab.value === value);
    if (selectedTab) {
      navigate(selectedTab.path);
      setTransferType(selectedTab.value);
    }
  };

  if (isPending) {
    <p>...</p>;
  }
  return (
    <div className="  flex flex-col gap-4 w-full    ">
      {/* {balance} */}
      <div className="figure-wrapper ">
        <div className="flex items-center gap-2">
          <p className="figure-wrapper-ttile-text">موجودی قابل برداشت</p>
          <img
            src={icons.info}
            alt="info"
            className="size-3 md:size-4 lg:size-5"
          />
        </div>
        <div className="flex items-center gap-2">
          <p dir="ltr" className="figure-wrapper-balance-text">
            {" "}
            <NumericFormat
              value={balance?.rial}
              displayType={"text"}
              thousandSeparator={true}
            />
          </p>
          <img
            src={icons.rial}
            alt="info"
            className="size-5 md:size-8 lg:size-10"
          />
        </div>
      </div>

      <div className="figure-wrapper gap-3 ">
        <TabSwitcher
          activeTab={transferType}
          handleSwitch={handleSwitch}
          options={tabOptions}
        />

        <Outlet />
      </div>
    </div>
  );
}

export default WithdrawalsLayout;
